export default "__VITE_ASSET__BrP0mHw$__"